import React, { useState, useEffect } from "react";

const Timeline = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const steps = [
    { text1: "Personalized", text2: "Nutrition Prescription" },
    { text1: "Built on", text2: "research-based clinical studies" },
    { text1: "Holistic health", text2: "coaching" },
    { text1: "One-on-one consultation", text2: "and personalised guidance" },
  ];

  useEffect(() => {
    const highlightSteps = () => {
      for (let i = 0; i < steps.length; i++) {
        setTimeout(() => {
          setActiveIndex(i);
        }, i * 3000);
      }
    };

    highlightSteps();

    return () => clearTimeout();
  }, []);

  return (
    <div className="flex flex-col space-y-8 pt-20 pb-20 px-6 timeline-container">
      <div className="relative flex flex-col items-center md:flex-row justify-around w-full gap-16">
        {steps.map((_, index) => (
          <div key={index} className="flex flex-col items-center relative z-10">
            <div
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
              className={`w-6 h-6 rounded-full cursor-pointer timelinegap transition-transform duration-200 ${activeIndex === index
                ? "bg-[#c0c9f6] border-2 border-[#7589ed] scale-150"
                : "bg-[#c0c9f6] border-2 border-transparent"
                }`}
            ></div>

            {activeIndex === index && (
              <div
                className={`${activeIndex === index ? "font-bold text-black" : "font-normal text-[#9e9999]"
                  } text-center text-sm md:text-md transition-all duration-200 font-lato md:hidden block mt-2`} // `md:hidden block` makes it visible only on mobile
              >
                <div>{steps[index].text1}</div>
                <div>{steps[index].text2}</div>
              </div>
            )}
          </div>
        ))}
        <div className="absolute top-2 left-0 w-full border-t-2 border-gray-200 hidden sm:block"></div>
      </div>

      <div className="relative timeline-container flex flex-col md:flex-row justify-between w-full mt-12 space-y-6 md:space-y-0 md:space-x-8">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`text-center text-sm md:text-md transition-all duration-200 font-lato ${activeIndex === index ? "font-bold text-black" : "font-normal text-[#9e9999]"
              } hover:text-black break-words max-w-xs md:max-w-xs md:w-1/4 mx-auto md:mx-0 custom-step-spacing md:block`}
          >
            <div>{step.text1}</div>
            <div>{step.text2}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
